module.exports = __webpack_public_path__ + "img/20210730_122420.031a7b27.jpg";